// src/use-beamer.ts
import * as React from "react";
import { useScript } from "@clara/hooks";
var BEAMER_URL = "https://app.getbeamer.com/js/beamer-embed.js";
var useBeamer = (options) => {
  const [loading, error] = useScript({
    src: BEAMER_URL,
    checkForExisting: true
  });
  const beamer = React.useRef(null);
  React.useEffect(() => {
    if (loading)
      return;
    if (!(options.user_id && options.product_id))
      return;
    if (error || !window.Beamer) {
      console.error("Error loading Beamer", error);
      return;
    }
    window.beamer_config = {
      ...options
    };
    beamer.current = window.Beamer;
  }, [loading, error, options, options.user_id, beamer]);
  const ready = beamer.current != null && !loading;
  return {
    error,
    ready
  };
};

export {
  useBeamer
};
